// Site entry — loaded by every HTML page.
// Handles global styles, Bootstrap interactions, the lazy-loaded React widget,
// and the contact form submission.

import "@sde/styles/main";
import { Carousel, Tooltip } from "bootstrap";
import { mountContactForm } from "./contact-form";
import { mountRandomQuote } from "./random-quote";

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new Tooltip(el));
document.querySelectorAll('.carousel').forEach(el => new Carousel(el));

mountRandomQuote();

if (document.querySelector("[data-sde-picker]")) {
  // The widget ships as an ES module. In dev this resolves via the pnpm
  // workspace symlink to apps/widget/src/main.tsx; in production the
  // site build first runs `turbo run build --filter=@sde/widget` and
  // imports the emitted dist/sde-widget.js bundle.
  import("@sde/widget");
}

if (document.querySelector("#contactform")) {
  mountContactForm();
}
